import { ASSETS } from "../mock";

export default function SectionTitle({ children, className = "" }) {
  return (
    <div className={`flex items-center justify-center gap-4 my-14 ${className}`}>
      <img src={ASSETS.smallLeaf} alt="" className="w-10 opacity-70" />
      <h2 className="section-title text-4xl sm:text-6xl">{children}</h2>
      <img src={ASSETS.smallLeaf} alt="" className="w-10 opacity-70 -scale-x-100" />
    </div>
  );
}
